import { Typography } from "@mui/material";
import { useLayoutEffect } from "react";

export const ResolvePaymentComponent = (() => {
    useLayoutEffect(() => {
        /* console.log(location?.search?.split("-")?.length)
        console.log(location?.search?.split("-")) */
        // if (!(location?.search?.split("-")?.length === 2)) {
        //     window.location.replace("/")
        // }
    }, [])
    return <>
        <div style={{
            position: "absolute",
            top: "0%",
            left: "0%",
            height: " 100%",
            width: "100%",
            margin: "0px",
            background: "radial-gradient(circle, #240015 0%, #12000b 100%)",
            overflow: "hidden",
            animation: "hueRotate 6s ease-in-out 3s infinite"
        }}><svg style={{ width: "100%" }} width="285" height="120" viewBox="0 0 285 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M240 66.4L248.6 75H255.1L240 59.9L225 75H231.5L240 66.4ZM240 53.6L231.4 45H225L240 60L255 45H248.6L240 53.6Z" fill="#0B82EA" />
                <path d="M58 42.1L74 58.2H86L58 30L30 58.1H42L58 42.1ZM58 78L42 61.9H30L58 90L86 61.9H74L58 78Z" fill="#0B82EA" />
                <path d="M116 63C115.4 62 114.5 61.2 113.4 60.6C112.3 60 111.2 59.5 109.8 59.1C108.5 58.7 107.2 58.4 105.9 58.1C104.6 57.8 103.4 57.4 102.4 57.1C101.3 56.7 100.5 56.2 99.7999 55.6C99.0999 55 98.7999 54.1 98.7999 53.1C98.7999 52.2 98.9999 51.4 99.4999 50.7C99.9999 50 100.8 49.4 101.9 49C103 48.6 104.4 48.3 106.1 48.3C107.4 48.3 108.8 48.5 110.3 48.9C111.7 49.3 113.1 49.9 114.4 50.7L115.8 47.3C114.5 46.4 113 45.8 111.3 45.3C109.6 44.8 107.9 44.6 106.1 44.6C103.5 44.6 101.3 45 99.5999 45.8C97.8999 46.6 96.6999 47.6 95.7999 48.9C94.9999 50.2 94.5999 51.6 94.5999 53.1C94.5999 54.7 94.8999 56 95.5999 57C96.1999 58 97.0999 58.8 98.1999 59.4C99.2999 60 100.5 60.5 101.8 60.9C103.1 61.3 104.4 61.6 105.7 61.9C107 62.2 108.2 62.5 109.2 62.9C110.3 63.3 111.2 63.8 111.8 64.4C112.5 65 112.8 65.8 112.8 66.9C112.8 67.8 112.5 68.6 112 69.3C111.5 70 110.7 70.5 109.6 70.9C108.5 71.3 107.1 71.5 105.4 71.5C103.5 71.5 101.6 71.2 99.8999 70.5C98.0999 69.8 96.6999 69 95.4999 68L93.8999 71.3C95.0999 72.4 96.6999 73.3 98.7999 74C100.9 74.7 103.1 75 105.4 75C108 75 110.2 74.6 111.9 73.8C113.6 73 114.9 72 115.8 70.7C116.6 69.4 117 68 117 66.5C117 65.2 116.7 64 116 63ZM123.3 45V75H127.6V45H123.3ZM154.8 70.7C153.4 71.3 151.8 71.6 150.2 71.6C148.5 71.6 146.9 71.3 145.5 70.7C144.1 70.1 142.8 69.3 141.8 68.3C140.7 67.3 139.9 66.1 139.3 64.7C138.7 63.3 138.5 61.7 138.5 60.1C138.5 58.4 138.8 56.9 139.3 55.5C139.9 54.1 140.7 52.8 141.8 51.8C142.8 50.8 144.1 50 145.5 49.4C147 48.8 148.5 48.5 150.2 48.5C151.8 48.5 153.4 48.8 154.8 49.4C156.2 50 157.5 50.9 158.7 52.1L161.5 49.4C160.1 47.9 158.5 46.7 156.5 45.9C154.6 45.1 152.4 44.7 150.1 44.7C147.8 44.7 145.7 45.1 143.8 45.9C141.9 46.6 140.2 47.7 138.8 49.1C137.4 50.5 136.3 52.1 135.5 53.9C134.7 55.8 134.3 57.8 134.3 60C134.3 62.2 134.7 64.3 135.5 66.1C136.3 67.9 137.4 69.6 138.8 71C140.2 72.4 141.9 73.5 143.8 74.2C145.8 74.9 147.9 75.3 150.1 75.3C152.4 75.3 154.6 74.9 156.5 74.1C158.5 73.3 160.1 72.1 161.5 70.6L158.7 67.9C157.5 69.2 156.2 70.1 154.8 70.7Z" fill="white" />
                <path d="M215.8 65C216.1 64.9 216.4 64.8 216.6 64.7C218.4 63.9 219.9 62.7 220.9 61.1C221.9 59.5 222.4 57.7 222.4 55.5C222.4 53.3 221.9 51.5 220.9 49.9C219.9 48.3 218.5 47.1 216.6 46.3C214.7 45.5 212.5 45.1 209.9 45.1H198.2V75.1H202.5V66H209.9C210.6 66 211.2 66 211.8 65.9L218.3 75.1H223L215.8 65ZM209.8 62.2H202.5V48.7H209.8C212.5 48.7 214.6 49.3 216 50.5C217.4 51.7 218.2 53.3 218.2 55.5C218.2 57.6 217.5 59.3 216 60.5C214.6 61.7 212.5 62.2 209.8 62.2Z" fill="white" />
                <path d="M180.1 45H175.9L162.3 75H166.7L170 67.5H185.9L189.2 75H193.7L180.1 45ZM171.5 64.1L178 49.4L184.5 64.1H171.5Z" fill="white" />
            </svg>
            <Typography sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                width: "100%",
                marginTop: "0px!important",
                textAlign: "center",
                fontSize: "128px",
                textTransform: "uppercase",
                transform: "translate(-50%, -50%)",
                display: "block",
                color: "#12000a",
                fontWeight: "300",
                fontFamily: "Audiowide",
                textShadow: "0px 0px 4px #12000a",
                animation: "fadeInText 3s ease-in 0s forwards, flicker4 5s linear 7.5s infinite, hueRotate 6s ease-in-out 3s infinite",
                "@keyframes flicker4": {
                    "0%": { color: "#ff005d", textShadow: "0px 0px 4px #ff005d" },
                    "30%": { color: "#ff005d", textShadow: "0px 0px 4px #ff005d" },
                    "31%": { color: "#12000a", textShadow: "0px 0px 4px #12000a" },
                    "32%": { color: "#ff005d", textShadow: "0px 0px 4px #ff005d" },
                    "36%": { color: "#ff005d", textShadow: "0px 0px 4px #ff005d" },
                    "37%": { color: "#12000a", textShadow: "0px 0px 4px #12000a" },
                    "41%": { color: "#12000a", textShadow: "0px 0px 4px #12000a" },
                    "42%": { color: "#ff005d", textShadow: "0px 0px 4px #ff005d" },
                    "85%": { color: "#ff005d", textShadow: "0px 0px 4px #ff005d" },
                    "86%": { color: "#12000a", textShadow: "0px 0px 4px #12000a" },
                    "95%": { color: "#12000a", textShadow: "0px 0px 4px #12000a" },
                    "96%": { color: "#ff005d", textShadow: "0px 0px 4px #ff005d" },
                    "100%": { color: "#ff005d", textShadow: "0px 0px 4px #ff005d" },
                },
                "@keyframes fadeInText": {
                    "1%  ": { color: "#12000a;text-shadow:0px 0px 4px #12000a" },
                    "70% ": { color: "#ff005d;text-shadow:0px 0px 14px #ff005d" },
                    "100%": { color: "#ff005d;text-shadow:0px 0px 4px #ff005d" },
                },

                "@keyframes hueRotate": {
                    "0%": {
                        filter: "hue-rotate(0deg)"
                    },
                    "50%": {
                        filter: "hue-rotate(-120deg)"
                    },
                    "100%": {
                        filter: "hue-rotate(0deg)"
                    }
                },
                "@media (max-width: 900px)": {
                    fontSize: "60px"
                }
            }}>¡Gracias por su compra!</Typography>
        </div >
    </>
})